import { ComboBoxOption } from "./Input";

export const opusOptions: ComboBoxOption<number>[] = [
    { label: "01 - Opus I", value: 1 },
    { label: "02 - Opus II", value: 2 },
    { label: "03 - Opus III", value: 3 },
    { label: "04 - Opus IV", value: 4 },
    { label: "05 - Opus V", value: 5 },
    { label: "06 - Opus VI", value: 6 },
    { label: "07 - Opus VII", value: 7 },
    { label: "08 - Opus VIII", value: 8 },
    { label: "09 - Opus IX", value: 9 },
    { label: "10 - Opus X", value: 10 },
    { label: "11 - Opus XI", value: 11 },
    { label: "12 - Opus XII", value: 12 },
    { label: "13 - Opus XIII", value: 13 },
    { label: "14 - Opus XIV", value: 14 },
    { label: "15 - Crystal Dominion", value: 15 },
    { label: "16 - Emissaries of Light", value: 16 },
    { label: "17 - Rebellion's Call", value: 17 },
    { label: "18 - Resurgence of Power", value: 18 },
    { label: "19 - From Nightmares", value: 19 },
    { label: "20 - Dawn of Heroes", value: 20 },
    { label: "21 - Beyond Destiny", value: 21 },
    { label: "22 - Hidden Hope", value: 22 },
    { label: "23 - Hidden Trials", value: 23 },
    { label: "24 - Hidden Legends", value: 24 },
    { label: "25 - Tears of the Planet", value: 25 },
    { label: "26 - Gunslinger in the Abyss", value: 26 },
    { label: "A - Advertisement", value: -4 },
    { label: "B - Boss Deck", value: -2 },    
    { label: "C - Crystal", value: -1 },
    { label: "PR - Promo", value: -3 },
    { label: "Re - Reprint", value: -5},
    { label: "W24 - Worlds 2024", value: -6}
];

export const opusStrings = ["W24", "Re", "A", "PR", "B", "C", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26"] as const;
export type OpusString = typeof opusStrings[number];

export const opusStringToId: Record<OpusString, number> = {
    "W24": -6,
    "Re": -5,
    "A": -4,
    "PR": -3,
    "B": -2,
    "C": -1,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    "10": 10,
    "11": 11,
    "12": 12,
    "13": 13,
    "14": 14,
    "15": 15,
    "16": 16,
    "17": 17,
    "18": 18,
    "19": 19,
    "20": 20,
    "21": 21,
    "22": 22,
    "23": 23,
    "24": 24,
    "25": 25,
    "26": 26
}

export const opusIdToString: Record<number, OpusString> = {
    [-6]: "W24",
    [-5]: "Re",
    [-4]: "A",
    [-3]: "PR",
    [-2]: "B",
    [-1]: "C",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    10: "10",
    11: "11",
    12: "12",
    13: "13",
    14: "14",
    15: "15",
    16: "16",
    17: "17",
    18: "18",
    19: "19",
    20: "20",
    21: "21",
    22: "22",
    23: "23",
    24: "24",
    25: "25",
    26: "26"
}